(() => {
  "use strict";

  if (document.querySelector(".cvCorneliusLauncher")) return;

  const avatarUrl = window.coreVitalCorneliusAvatarUrl;
  if (!avatarUrl) return;

  const button = document.createElement("button");
  button.type = "button";
  button.className = "cvCorneliusLauncher";
  button.hidden = true;
  button.setAttribute("aria-label", "Open chat with Cornelius, the Core Vital Guide");
  button.setAttribute("aria-haspopup", "dialog");

  const avatar = document.createElement("img");
  avatar.src = avatarUrl;
  avatar.alt = "";
  avatar.width = 50;
  avatar.height = 50;

  const label = document.createElement("span");
  label.textContent = "Ask Cornelius";
  button.append(avatar, label);
  document.body.append(button);

  let connectedApi = null;

  const showLauncher = () => {
    button.hidden = false;
    button.removeAttribute("aria-busy");
  };

  const hideLauncher = () => {
    button.hidden = true;
  };

  const connect = () => {
    const api = window.tidioChatApi;
    if (!api || connectedApi === api) return Boolean(api);
    connectedApi = api;

    const minimizeToCornelius = () => {
      api.hide();
      showLauncher();
    };

    api.on("ready", minimizeToCornelius);
    api.on("open", hideLauncher);
    api.on("close", minimizeToCornelius);

    try {
      api.hide();
      showLauncher();
    } catch {
      button.setAttribute("aria-busy", "true");
    }
    return true;
  };

  document.addEventListener("tidioChat-ready", connect, { once: true });
  connect();

  let attempts = 0;
  const apiWaiter = window.setInterval(() => {
    attempts += 1;
    if (connect() || attempts >= 80) window.clearInterval(apiWaiter);
  }, 125);

  button.addEventListener("click", () => {
    const api = window.tidioChatApi;
    if (!api) return;
    hideLauncher();
    api.show();
    api.open();
  });
})();
